export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_formulaTitle') ||'公式名称',
    field: 'formulaTitle',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    fixed: 'left',
  },
  {
    title: that.$l('table_label_formulaExplain') ||'公式说明',
    field: 'formulaExplain',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_label_productLine') || '产品线',
    field: 'v_productLine',
    width: 130,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('table_label_categoryName') ||'分类',
    field: 'categoryName',
    width: 120,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    field: 'createByName',
    title: that.$l('INDEX.table_label_creator') || '创建人',
    width: 100,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.create_date') || '创建时间',
    field: 'createDate',
    width: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    width: 100,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    width: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
]
